import * as types from "../redux/types";
import backend from "../api/api";
import { store } from "../redux/store";
import { message } from "antd";

const getConfig = () => {
  const token = store.getState().auth.token;
  return {
    headers: {
      Authorization: `Token ${token}`,
    },
  };
};

export const getGlobalLeaves = () => async (dispatch) => {
  try {
    const res = await backend.get("api/hrm/global-leave/", getConfig());
    dispatch({
      type: types.GET_GLOBAL_LEAVES,
      payload: res.data,
    });
  } catch (error) {
    console.error(error);
    message.error("Failed to fetch global leaves");
  }
};

export const getSpecificGlobalLeave = (id) => async (dispatch) => {
  try {
    const res = await backend.get(`api/hrm/global-leave/${id}/`, getConfig());
    dispatch({
      type: types.GET_SPECIFIC_GLOBAL_LEAVES,
      payload: res.data,
    });
  } catch (error) {
    console.error(error);
    message.error("Failed to fetch global leave details");
  }
};

export const createGlobalLeave = (formValues) => async (dispatch) => {
  try {
    const res = await backend.post("api/hrm/global-leave/", formValues, getConfig());
    if (res.status === 201) {
      dispatch({
        type: types.CREATE_GLOBAL_LEAVE,
        payload: res.data,
      });
      message.success("Global Leave created successfully");
    }
  } catch (error) {
    console.error(error);
    message.error("Failed to create global leave");
  }
};

export const updateGlobalLeave = (id, formValues) => async (dispatch) => {
  try {
    const res = await backend.put(`api/hrm/global-leave/${id}/`, formValues, getConfig());
    if (res.status === 200) {
      dispatch({
        type: types.UPDATE_GLOBAL_LEAVE,
        payload: res.data,
      });
      message.success("Global Leave updated successfully");
    }
  } catch (error) {
    console.error(error);
    message.error("Failed to update global leave");
  }
};

export const deleteGlobalLeave = (id) => async (dispatch) => {
  try {
    const res = await backend.delete(`api/hrm/global-leave/${id}/`, getConfig());
    if (res.status === 204) {
      dispatch({
        type: types.DELETE_GLOBAL_LEAVE,
        payload: id,
      });
      message.success("Global Leave deleted successfully");
    }
  } catch (error) {
    console.error(error);
    message.error("Failed to delete global leave");
  }
};
